export const INTERNAL_ERROR_OVERLOAD = 'INTERNAL_ERROR_OVERLOAD';
export const INTERNAL_ERROR_NO_CONTAINER = 'INTERNAL_ERROR_NO_CONTAINER';
export const INTERNAL_ERROR_UNKNOWN = 'INTERNAL_ERROR_UNKNOWN';
export const INTERNAL_ERROR_NO_SOURCE = 'INTERNAL_ERROR_NO_SOURCE';
export const INTERNAL_ERROR_GET_PLAYER = 'INTERNAL_ERROR_GET_PLAYER';

export const PLAYER_ERROR = 'PLAYER_ERROR';
